// Interface for Insights Keyword 
export interface InsightsKeyword {
    keyword: string;
    quantity: number;
}

export interface InsightsKeywordState {
    keywords: InsightsKeyword[],
    loading: boolean,
    error: string | null;
}

export const initialInsightsKeywordsState: InsightsKeywordState = {
    keywords: [],
    loading: false,
    error: null,
}
